module.exports = __webpack_public_path__ + "img/icon_visit_registration_calendar.af00a934.svg";